import { objHasProp } from 'newJs/utils';
import { ATTACHMENTS } from 'newJs/config';

const { CLICK_ACTIONS: { SAVE_TO_CONTACTS, SAVE_TO_FILES_ALL, SAVE_TO_FOTO } } = ATTACHMENTS;

export const getTooltipText = (i18n, name) => {
    const { contacts, foto, files } = i18n;
    const strings = {
        [SAVE_TO_CONTACTS]: {
            default: contacts.saveTo,
            failed: contacts.saveFailed,
            success: contacts.saveSingleSuccess
        },
        [SAVE_TO_FOTO]: {
            default: foto.saveTo,
            failed: foto.saveFailed,
            success: foto.saveSingleSuccess
        },
        [SAVE_TO_FILES_ALL]: {
            default: files.saveAll,
            failed: files.saveFailed,
            success: files.saveAllSuccess
        },
        default: {
            default: files.saveTo,
            failed: files.saveFailed,
            success: files.saveSingleSuccess
        }
    };
    return objHasProp(name, strings) ? strings[name] : strings.default;
};

export const parseResponse = (obj) => {
    const hasError = obj.result.some((item) => {
        if (!objHasProp('error', item)) {
            return false;
        }
        // Foto returns null instead of false
        else if (item.error === null) {
            return false;
        }
        return item.error;
    });

    return { hasError, url: obj.url };
};
